import React, { useEffect, useState, useRef } from "react";
import { useHistory, useLocation, useParams, Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import "../../assets/styles/local/TaskDelete.css";
import closeIcon from "../../assets/icons/x-circle.svg";

import "../../assets/styles/local/TemplateBuilder.css";

const TemplateNamePopup = (props) => {
  const [templateName, setTemplateName] = useState("");

  return (
    <>
      <style jsx>{`
        #asc .modal-content {
          background: #f1f1f1;
        }
      `}</style>

      <Modal
        id="asc"
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        className="template-name-add"
        centered
      >
        <div className="text-center">
          <div>
            <div className="d-flex gap-3 justify-content-center">
              <p className="firstHead pt- mb-0" style={{ color: "#333333" }}>
                Give a name to the form to turn it unique
              </p>

              <img
                className="pointer"
                src={closeIcon}
                alt=""
                style={{
                  marginLeft: "3vw",
                }}
                onClick={() => {
                  props.handleCancel();
                }}
              />
            </div>

            <p
              className="mb-0 text-start ps-5 ms-1 pt-4 pb-1"
              style={{ fontSize: "12px" }}
            >
              Form name
            </p>
            <div
              className="firstHead mx-5"
              style={{ color: "#333333", width: "63%" }}
            >
              <input
                type="email"
                placeholder="Enter Form Name"
                value={templateName}
                className="text-start p-3"
                style={{
                  color: "#333333",
                  border: "none",
                  background: "unset",
                  borderRadius: "10px",
                  background: "#fff",
                  width: "300px",
                }}
                onChange={(e) => {
                  setTemplateName(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="d-flex justify-content-center flex-wrap gap-4 pt-5">
            <button
              className="add-template-name-btn p-2"
              disabled={templateName === ""}
              onClick={() => {
                props.handleAddName(templateName);
              }}
            >
              Add
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TemplateNamePopup;
